// extracted by mini-css-extract-plugin
export default {"form":"FormPOJob_form__eHkwH","productWrap":"FormPOJob_productWrap__eiISq","groupTitle":"FormPOJob_groupTitle__2CfiM"};